// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3-Xar","file":"styles_file__11g8c"};